<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <h4 class="text-center mb-4">نتیجه افزایش موجودی</h4>
            <div :class="`mb-0 alert alert-${callbackDetails.status ? 'success' : 'danger'}`">
                <p class="mb-0">{{ callbackDetails.message }}</p>
                <p class="mb-0 mt-3" v-if="callbackDetails.status">موجودی فعلی کیف پول : {{ deposit }} ریال</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Callback',
    data(){
        return {
            showLoading: true,
            deposit: 0,
            callbackDetails: {}
        }
    },
    methods: {
        getData(){
            const token = this.$route.params.token;
            this.$api.post('Organizations/Wallet/CallBack/Inquery/' + token).then(({data}) => {
                this.callbackDetails = data.result;
                if(this.callbackDetails.status){
                    this.$api.get('Organizations/Wallet/Balance').then(response => {
                        if(response.data.status)
                            this.deposit = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(response.data.result);
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>